export default "__VITE_ASSET__e6329cc4__"